import React from "react";
import { Row, Col, Collapse, Button } from "reactstrap";
import { Range, getTrackBackground } from "react-range";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { Container } from "./InfoSection.elements";
import {
  GetProductsForHome,
  GetRegionList,
  GetMinMaxPrice,
} from "../../api/Product";
import { GetOperatorList } from "../../api/Operator";
import { GetAllProductType } from "../../api/ProductType";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "../../scss/style.css";
import ServicePlanCard from "../ServicePlanCard/ServicePlanCard";
import { IsRechargeProduct } from "../../api/Recharge";
import PurchaseConfirmModal from "../PurchaseConfirmModal/PurchaseConfirmModal";
import { getProductsWithCountryData } from "./data";

class InfoSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isDestinationsLoading: true,
      isExpired: false,
      products: [],
      operators: [],
      regions: [],
      types: [],
      selectedOperator: { value: 0, label: "All" },
      selectedRegion: { value: 0, label: "All" },
      selectedType: { value: 0, label: "All" },
      minPrice: 10,
      maxPrice: 100,
      priceRange: [10, 100],
      tempPriceRange: [10, 100],
      sortBy: "catalog",
      searchQuery: props.searchQuery || "",
      regionSearchQuery: "",
      typeSearchQuery: "",
      openMenus: {
        destination: true,
        type: true,
        price: true,
      },
      currentPage: 1,
      rowPerPage: 30,
      totalRecord: 0,
      showConfirmModal: false,
      selectedProduct: null,
      selectedRenewalContext: null,
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleLoadMore = this.handleLoadMore.bind(this);
    this.handleBuyClick = this.handleBuyClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.searchQuery !== this.props.searchQuery) {
      if (this.props.searchQuery !== "") {
        this.setState(
          {
            selectedRegion: { value: 0, label: "All" },
            selectedType: { value: 0, label: "All" },
            regionSearchQuery: "",
            currentPage: 1,
            products: [],
          },
          () => this.loadData()
        );
      }
    }
  }

  componentDidMount() {
    this.loadInitialData();
    const { location } = this.props;
    if (location && location.state && location.state.filterRenewal) {
      this.setState({ filterRenewalProducts: true });
    }
  }

  async loadInitialData() {
    this.setState({ isLoading: true });
    try {
      const [operatorlist, regionlist, typelist] = await Promise.all([
        GetOperatorList(),
        GetRegionList(),
        GetAllProductType(),
      ]);

      const operators = operatorlist
        ? operatorlist.map((row) => ({
          id: row.operatorId,
          name: row.operatorName,
          isActive: row.isActive,
        }))
        : [];

      const regions =
        regionlist && regionlist.records
          ? regionlist.records.map((row) => ({
            id: row.regionId,
            name: row.regionName,
            operatorId: row.operatorId,
            countryId: row.countryId,
            countryName: row.countryName,
            description: row.description,
            isoCode: row.isoCode,
            flagPath: row.flagPath,
            countryCode: row.countryCode,
            regionImage: row.regionImage,
          }))
          : [];

      const types = typelist
        ? typelist.map((row) => ({ id: row.typeId, name: row.typeName }))
        : [];

      this.setState({
        operators,
        regions,
        types,
        isDestinationsLoading: false,
      });

      await this.fetchAndSetPriceRange(
        { value: 0 },
        { value: 0 },
        { value: 0 },
        this.props.searchQuery,
      );

      // const { initialCountryId } = this.props;
      // if (initialCountryId && initialCountryId > 0) {
      //   this.loadData();
      // } else {
      //   this.setState({ isLoading: false });
      // }
      this.loadData();

    } catch (error) {
      this.setState({ isExpired: true, isLoading: false, isDestinationsLoading: false });
      console.error("Error loading initial data:", error);
    }
  }

  async fetchAndSetPriceRange(selectedOperator, selectedType, selectedRegion, searchQuery) {
    const minmaxPrice = await GetMinMaxPrice(
      selectedOperator,
      selectedType,
      selectedRegion,
      searchQuery,
    );
    const minPrice = minmaxPrice ? minmaxPrice.minPrice : 0;
    const maxPrice = minmaxPrice ? minmaxPrice.maxPrice : 0;
    this.setState({
      minPrice,
      maxPrice,
      priceRange: [minPrice, maxPrice],
      tempPriceRange: [minPrice, maxPrice],
    });
  }

  async loadData(append = false) {
    const {
      selectedOperator,
      selectedType,
      selectedRegion,
      priceRange,
      sortBy,
      currentPage,
      rowPerPage,
      filterRenewalProducts,
    } = this.state;
    const { searchQuery } = this.props;

    const productlist = await GetProductsForHome(
      selectedOperator,
      selectedType,
      selectedRegion,
      priceRange[0],
      priceRange[1],
      sortBy,
      currentPage,
      rowPerPage,
      searchQuery,
    );

    const newProducts = [];
    if (productlist && productlist.records) {
      productlist.records.forEach((row) => {
        if (filterRenewalProducts && !row.isRenew) return;
        const sellPrice = row.sellPrice || 0;
        newProducts.push({
          id: row.productId,
          productName: row.productName,
          specification: row.specification,
          price: "K " + sellPrice.toLocaleString(),
          sellPrice,
          operatorId: row.operatorId,
          regionId: row.regionId,
          regionName: row.regionName,
          typeId: row.typeId,
          tags: row.tag ? row.tag.split(";") : [],
          expireInfo: row.expireInfo,
          expire: row.expire,
          typeName: row.typeName,
          roamskuId: row.roamskuId,
          productCode: row.productCode,
          isRenew: row.isRenew,
        });
      });

      if (this.props.onProductsLoaded) {
        this.props.onProductsLoaded(newProducts);
      }

      this.setState((prevState) => ({
        products: append ? [...prevState.products, ...newProducts] : newProducts,
        isLoading: false,
        totalRecord: productlist.totalCount,
      }));

      if (searchQuery && this.props.onSearchSubmit) {
        this.props.onSearchSubmit("");   // ← clears submittedSearchQuery in PortalLayout
      }
    } else {
      this.setState({ isLoading: false, totalRecord: productlist.totalCount || 0 });
    }
  }

  toggleMenu(menu) {
    this.setState((prevState) => ({
      openMenus: { ...prevState.openMenus, [menu]: !prevState.openMenus[menu] },
    }));
  }

  clearDestination = () => {
    this.setState({
      selectedRegion: { value: 0, label: "All" },
      regionSearchQuery: "",
      currentPage: 1,
      products: [],
      totalRecord: 0,
    });
  };

  handleRegionChange = (regionId) => {
    const { selectedOperator, selectedType } = this.state;
    this.setState(
      { selectedRegion: { value: regionId }, currentPage: 1, products: [] },
      async () => {
        await this.fetchAndSetPriceRange(
          selectedOperator,
          selectedType,
          this.state.selectedRegion,
          this.props.searchQuery,
        );
        this.loadData();
      },
    );
  };

  handleTypeChange = (typeId) => {
    const { selectedOperator, selectedRegion } = this.state;
    this.setState(
      { selectedType: { value: typeId }, currentPage: 1, products: [] },
      async () => {
        await this.fetchAndSetPriceRange(
          selectedOperator,
          this.state.selectedType,
          selectedRegion,
          this.props.searchQuery,
        );
        this.loadData();
      },
    );
  };

  handleFilterChange = (filterName, value) => {
    this.setState({ [filterName]: value, currentPage: 1, products: [] }, () =>
      this.loadData(),
    );
  };

  handleLoadMore = () => {
    this.setState(
      (prevState) => ({ currentPage: prevState.currentPage + 1 }),
      () => this.loadData(true),
    );
  };

  handleMinPriceChange = (e) => {
    const value = parseInt(e.target.value) || this.state.minPrice;
    this.setState((prevState) => ({
      tempPriceRange: [value, prevState.tempPriceRange[1]],
    }));
  };

  handleMaxPriceChange = (e) => {
    const value = parseInt(e.target.value) || this.state.maxPrice;
    this.setState((prevState) => ({
      tempPriceRange: [prevState.tempPriceRange[0], value],
    }));
  };

  applyPriceFilter = () => {
    this.setState(
      { priceRange: this.state.tempPriceRange, currentPage: 1, products: [] },
      () => this.loadData(),
    );
  };

  handleBuyClick = async (product) => {
    if (!this.props.auth.isAuth) {
      this.props.history.push({ pathname: "/memberLogin" });
      return;
    }

    const renewalContext = sessionStorage.getItem("renewalContext");
    const parsedRenewalContext = renewalContext ? JSON.parse(renewalContext) : null;

    let isRecharge = false;
    try {
      const result = await IsRechargeProduct(product.productId || product.id);
      isRecharge = !!(result && result.status && result.data && result.data.isRecharge);
    } catch (error) {
      console.error("Error checking product type:", error);
    }

    if (isRecharge) {
      // Recharge products keep the dedicated confirmation route
      this.props.history.push({
        pathname: "/home/confirmPage",
        state: { product, renewalContext: parsedRenewalContext },
      });
    } else {
      // eSIM products use the popup so filters/search results aren't lost
      this.setState({
        selectedProduct: product,
        selectedRenewalContext: parsedRenewalContext,
        showConfirmModal: true,
      });
    }
  };

  handleCloseConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  handleCloseConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  handleCloseConfirmModal = () => {
    this.setState({ showConfirmModal: false });
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page, isLoading: true }, () => {
      this.loadData(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  };

  reset = () => {
    const { minPrice, maxPrice } = this.state;
    if (this.props.onSearchSubmit) this.props.onSearchSubmit("");
    if (this.props.onSearch) this.props.onSearch("");
    this.setState(
      {
        searchQuery: "",
        regionSearchQuery: "",
        typeSearchQuery: "",
        selectedOperator: { value: 0, label: "All" },
        selectedRegion: { value: 0, label: "All" },
        selectedType: { value: 0, label: "All" },
        priceRange: [minPrice, maxPrice],
        tempPriceRange: [minPrice, maxPrice],
        sortBy: "default",
        openMenus: { destination: true, type: true, price: true },
        currentPage: 1,
        products: [],
      },
      () => this.loadData(),
    );
  };

  // hasActiveSelection() {
  //   const { selectedRegion } = this.state;
  //   const search = this.props.searchQuery;
  //   return (
  //     (selectedRegion && selectedRegion.value !== 0) ||
  //     (search && search.trim() !== "")
  //   );
  // }
  hasActiveSelection() {
    return true;
  }

  getFilteredRegions() {
    const query = (this.state.regionSearchQuery || "").toLowerCase();
    return this.state.regions
      .filter(
        (r) =>
          !query ||
          r.name.toLowerCase().includes(query) ||
          (r.countryName && r.countryName.toLowerCase().includes(query)) ||
          (r.description && r.description.toLowerCase().includes(query)),
      )
      .sort((a, b) => a.name.localeCompare(b.name));
  }

  renderDestinationFilter() {
    const { selectedRegion, openMenus, isDestinationsLoading, regionSearchQuery } = this.state;
    const regions = this.getFilteredRegions();
    const selectedRegionObj = this.state.regions.find((r) => r.id === selectedRegion.value);

    return (
      <div style={{ marginBottom: "25px", padding: "15px", border: "1px solid #ddd", borderRadius: "5px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer",
            marginBottom: openMenus.destination ? "15px" : "0",
          }}
          onClick={() => this.toggleMenu("destination")}
        >
          <h5 style={{ fontWeight: "bold", margin: 0, fontSize: "16px" }}>Destination</h5>
          {openMenus.destination ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
        </div>

        <Collapse isOpen={openMenus.destination}>
          {/* Search input */}
          <div style={{ marginBottom: "8px" }}>
            <input
              type="text"
              placeholder="Search region..."
              value={regionSearchQuery}
              onChange={(e) => this.setState({ regionSearchQuery: e.target.value })}
              style={{
                width: "100%",
                padding: "8px 12px",
                border: "1px solid #ddd",
                borderRadius: "4px",
                fontSize: "14px",
                boxSizing: "border-box",
              }}
            />
          </div>

          {/* Selected region badge */}
          {selectedRegionObj && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                padding: "6px 10px",
                backgroundColor: "#e6f2ff",
                border: "1px solid #007bff",
                borderRadius: "4px",
                fontSize: "13px",
                marginBottom: "8px",
                color: "#0056b3",
                fontWeight: "600",
              }}
            >
              <span style={{ flex: 1, marginRight: "6px" }}>{selectedRegionObj.name}</span>
              <button
                onClick={this.clearDestination}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "#0056b3",
                  fontSize: "18px",
                  lineHeight: 1,
                  padding: 0,
                }}
              >
                &times;
              </button>
            </div>
          )}

          {/* Region list */}
          {isDestinationsLoading ? (
            <div style={{ textAlign: "center", padding: "12px", color: "#666", fontSize: "13px" }}>
              Loading...
            </div>
          ) : (
            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                maxHeight: "220px",
                overflowY: "auto",
                border: "1px solid #eee",
                borderRadius: "4px",
              }}
            >
              {regions.length === 0 ? (
                <li style={{ padding: "10px 12px", color: "#888", fontSize: "13px" }}>
                  {regionSearchQuery
                    ? `No results for "${regionSearchQuery}"`
                    : "No regions available."}
                </li>
              ) : (
                regions.map((region) => (
                  <li
                    key={region.id}
                    onClick={() => this.handleRegionChange(region.id)}
                    style={{
                      padding: "8px 12px",
                      fontSize: "13px",
                      cursor: "pointer",
                      backgroundColor: selectedRegion.value === region.id ? "#e6f2ff" : "#fff",
                      color: selectedRegion.value === region.id ? "#0056b3" : "#333",
                      fontWeight: selectedRegion.value === region.id ? "600" : "400",
                      borderBottom: "1px solid #f0f0f0",
                    }}
                    onMouseEnter={(e) => {
                      if (selectedRegion.value !== region.id)
                        e.currentTarget.style.backgroundColor = "#f5f5f5";
                    }}
                    onMouseLeave={(e) => {
                      if (selectedRegion.value !== region.id)
                        e.currentTarget.style.backgroundColor = "#fff";
                    }}
                  >
                    {region.name}
                  </li>
                ))
              )}
            </ul>
          )}
        </Collapse>
      </div>
    );
  }

  renderServicePlanCard() {
    const { products, regions } = this.state;
    const productsData = getProductsWithCountryData(products, regions);

    return (
      <div className="App" style={{ width: "100%" }}>
        <div className="card-container" style={{ width: "100%", justifyContent: "center" }}>
          {productsData.map((product) => (
            <ServicePlanCard
              id={product.id}
              key={product.id}
              isoCode={product.isoCode}
              regionName={product.regionName}
              regionImage={product.regionImage}
              productType={product.productType}
              price={product.price}
              isRenew={product.isRenew}
              isMultiRegion={product.isMultiRegion}
              details={product.details}
              product={product.product}
              history={this.props.history}
              auth={this.props.auth}
              onBuyClick={this.handleBuyClick}
            />
          ))}
        </div>
      </div>
    );
  }

  renderPagination() {
    const { products, totalRecord, rowPerPage, currentPage, isLoading } = this.state;
    const { searchQuery } = this.props;
    const totalPages = Math.ceil(totalRecord / rowPerPage);

    if (products.length === 0) {
      if (isLoading) {
        return (
          <div style={{ textAlign: "center", marginTop: 60, marginBottom: 40 }}>
            <div
              style={{
                width: "48px", height: "48px",
                border: "4px solid #e9ecef", borderTopColor: "#1E90FF",
                borderRadius: "50%", animation: "spin 0.8s linear infinite",
                margin: "0 auto 20px auto",
              }}
            />
            <p style={{ color: "#999", fontSize: "14px" }}>Loading products...</p>
          </div>
        );
      }
      return (
        <div
          style={{
            textAlign: "center", marginTop: 40, marginBottom: 40,
            padding: "40px 20px", backgroundColor: "#f8f9fa", borderRadius: "8px",
          }}
        >
          <i className="fa fa-search" style={{ fontSize: "48px", color: "#ccc", marginBottom: "15px" }}></i>
          <h4 style={{ color: "#333", marginBottom: "10px" }}>
            {searchQuery && searchQuery.trim() !== "" ? "No Products Match Your Search" : "No Plans Available"}
          </h4>
          <p style={{ color: "#666", fontSize: "14px", marginBottom: "15px" }}>
            {searchQuery && searchQuery.trim() !== ""
              ? `We couldn't find any products matching "${searchQuery}".`
              : "No plans are available for this selection. Please choose another destination."}
          </p>
        </div>
      );
    }

    const getPageNumbers = () => {
      const pages = [];
      const maxVisiblePages = 5;
      let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
      let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
      if (endPage - startPage < maxVisiblePages - 1)
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      for (let i = startPage; i <= endPage; i++) pages.push(i);
      return pages;
    };

    return (
      <div style={{ opacity: isLoading ? 0.6 : 1, pointerEvents: isLoading ? "none" : "auto" }}>
        {totalPages > 1 && (
          <div
            style={{
              display: "flex", justifyContent: "center", alignItems: "center",
              gap: "8px", marginTop: "30px", marginBottom: "15px", flexWrap: "wrap",
            }}
          >
            <Button
              onClick={() => this.handlePageChange(currentPage - 1)}
              disabled={currentPage === 1 || isLoading}
              style={{
                padding: "8px 12px",
                backgroundColor: currentPage === 1 ? "#e9ecef" : "#fff",
                border: "1px solid #ddd",
                color: currentPage === 1 ? "#999" : "#333",
              }}
            >
              &laquo; Prev
            </Button>

            {getPageNumbers().map((page) => (
              <Button
                key={page}
                onClick={() => this.handlePageChange(page)}
                disabled={isLoading}
                style={{
                  padding: "8px 14px",
                  backgroundColor: currentPage === page ? "#1E90FF" : "#fff",
                  border: "1px solid #ddd",
                  color: currentPage === page ? "#fff" : "#333",
                  fontWeight: currentPage === page ? "bold" : "normal",
                  minWidth: "40px",
                }}
              >
                {page}
              </Button>
            ))}

            <Button
              onClick={() => this.handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages || isLoading}
              style={{
                padding: "8px 12px",
                backgroundColor: currentPage === totalPages ? "#e9ecef" : "#fff",
                border: "1px solid #ddd",
                color: currentPage === totalPages ? "#999" : "#333",
              }}
            >
              Next &raquo;
            </Button>
          </div>
        )}

        <div style={{ textAlign: "center", color: "#666", fontSize: "14px", marginTop: "10px" }}>
          Showing {(currentPage - 1) * rowPerPage + 1} –{" "}
          {Math.min(currentPage * rowPerPage, totalRecord)} of {totalRecord} products
        </div>
      </div>
    );
  }

  render() {
    const { selectedType, minPrice, maxPrice, openMenus, isLoading } = this.state;

    return (
      <Container style={{ position: "relative", minHeight: "80vh" }}>
        <Row style={{ margin: 0 }}>

          {/* ── Sidebar ── */}
          <Col md={3} style={{ padding: "20px 15px", backgroundColor: "#fff", borderRight: "1px solid #eee" }}>

            <Button
              style={{
                width: "100%", backgroundColor: "#000", color: "#fff",
                fontSize: "16px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", marginBottom: "20px",
              }}
              onClick={() => this.reset()}
            >
              Reset
            </Button>

            {/* Destination filter */}
            {this.renderDestinationFilter()}

            {/* Type filter */}
            <div style={{ marginBottom: "25px", padding: "15px", border: "1px solid #ddd", borderRadius: "5px" }}>
              <div
                style={{
                  display: "flex", justifyContent: "space-between",
                  alignItems: "center", cursor: "pointer",
                  marginBottom: openMenus.type ? "15px" : "0",
                }}
                onClick={() => this.toggleMenu("type")}
              >
                <h5 style={{ fontWeight: "bold", margin: 0, fontSize: "16px" }}>Type</h5>
                {openMenus.type ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
              </div>

              <Collapse isOpen={openMenus.type}>
                <div style={{ marginBottom: "10px" }}>
                  <input
                    type="text"
                    placeholder="Search Type"
                    value={this.state.typeSearchQuery || ""}
                    onChange={(e) => this.setState({ typeSearchQuery: e.target.value })}
                    style={{
                      width: "100%", padding: "8px 12px",
                      border: "1px solid #ddd", borderRadius: "4px", fontSize: "14px",
                    }}
                  />
                </div>
                <ul style={{ listStyle: "none", padding: 0, margin: 0, maxHeight: "200px", overflowY: "auto" }}>
                  <li key="all" style={{ marginBottom: "8px" }}>
                    <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                      <input
                        type="radio" name="type"
                        checked={selectedType.value == 0}
                        onChange={() => this.handleTypeChange(0)}
                        style={{ marginRight: "10px" }}
                      />
                      <span style={{ fontSize: "14px" }}>No Filter</span>
                    </label>
                  </li>
                  {this.state.types
                    .filter((type) =>
                      !this.state.typeSearchQuery ||
                      type.name.toLowerCase().includes(this.state.typeSearchQuery.toLowerCase())
                    )
                    .map((type) => (
                      <li key={type.id} style={{ marginBottom: "10px" }}>
                        <label style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                          <input
                            type="radio" name="type"
                            checked={selectedType.value === type.id}
                            onChange={() => this.handleTypeChange(type.id)}
                            style={{ marginRight: "10px" }}
                          />
                          <span style={{ fontSize: "14px" }}>{type.name}</span>
                        </label>
                      </li>
                    ))}
                </ul>
              </Collapse>
            </div>

            {/* Price filter */}
            <div style={{ marginBottom: "25px", padding: "15px", border: "1px solid #ddd", borderRadius: "5px" }}>
              <div
                style={{
                  display: "flex", justifyContent: "space-between",
                  alignItems: "center", cursor: "pointer",
                  marginBottom: openMenus.price ? "15px" : "0",
                }}
                onClick={() => this.toggleMenu("price")}
              >
                <h5 style={{ fontWeight: "bold", margin: 0, fontSize: "16px" }}>Price</h5>
                {openMenus.price ? <FaChevronUp size={14} /> : <FaChevronDown size={14} />}
              </div>

              <Collapse isOpen={openMenus.price}>
                {minPrice !== null && maxPrice !== null ? (
                  <>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
                      <span style={{ fontSize: "14px", fontWeight: "bold" }}>K{(minPrice || 0).toLocaleString()}</span>
                      <span style={{ fontSize: "14px", fontWeight: "bold" }}>K{(maxPrice || 0).toLocaleString()}</span>
                    </div>

                    <div style={{ marginBottom: "15px", padding: "0 5px" }} className="container">
                      <Range
                        step={1} min={minPrice} max={maxPrice}
                        values={this.state.tempPriceRange}
                        onChange={(values) => this.setState({ tempPriceRange: values })}
                        renderTrack={({ props, children }) => (
                          <div
                            {...props}
                            style={{
                              ...props.style, height: "6px", display: "flex",
                              width: "100%", borderRadius: "3px",
                              background: getTrackBackground({
                                values: this.state.tempPriceRange,
                                colors: ["#ddd", "#0096FB", "#ddd"],
                                min: minPrice, max: maxPrice,
                              }),
                              alignSelf: "center", margin: "0 10px",
                            }}
                          >
                            {children}
                          </div>
                        )}
                        renderThumb={({ props }) => (
                          <div
                            {...props}
                            style={{
                              height: "20px", width: "20px", borderRadius: "50%",
                              backgroundColor: "#fff", border: "2px solid #0096FB",
                              display: "flex", justifyContent: "center",
                              alignItems: "center", marginLeft: "-22px",
                            }}
                          />
                        )}
                      />
                    </div>

                    <div style={{ display: "flex", justifyContent: "space-between", gap: "10px", marginBottom: "15px" }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: "12px", marginBottom: "5px", color: "#666" }}>From</div>
                        <input
                          type="number" value={this.state.tempPriceRange[0]}
                          onChange={this.handleMinPriceChange}
                          style={{ width: "100%", padding: "8px", border: "1px solid #ddd", borderRadius: "4px", fontSize: "14px" }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: "12px", marginBottom: "5px", color: "#666" }}>To</div>
                        <input
                          type="number" value={this.state.tempPriceRange[1]}
                          onChange={this.handleMaxPriceChange}
                          style={{ width: "100%", padding: "8px", border: "1px solid #ddd", borderRadius: "4px", fontSize: "14px" }}
                        />
                      </div>
                    </div>

                    <Button style={{ color: "white" }} onClick={this.applyPriceFilter} color="info">
                      Filter
                    </Button>
                  </>
                ) : (
                  <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
                    Loading price range...
                  </div>
                )}
              </Collapse>
            </div>
          </Col>

          {/* ── Main content ── */}
          <Col md={9} style={{ padding: "20px", backgroundColor: "#f8f9fa" }}>
            {this.hasActiveSelection() ? (
              <>
                <Row style={{ marginTop: "20px" }}>
                  {this.renderServicePlanCard()}
                </Row>
                {this.renderPagination()}
              </>
            ) : (
              <div style={{ textAlign: "center", marginTop: "80px", color: "#999" }}>
                <i className="fa fa-map-marker" style={{ fontSize: "48px", marginBottom: "16px" }}></i>
                <p style={{ fontSize: "16px" }}>Select a destination from the left panel to browse plans.</p>
              </div>
            )}
          </Col>

        </Row>

        <PurchaseConfirmModal
          isOpen={this.state.showConfirmModal}
          product={this.state.selectedProduct}
          renewalContext={this.state.selectedRenewalContext}
          onCancel={this.handleCloseConfirmModal}
          history={this.props.history}
        />
      </Container>


    );
  }
}

const mapStateToProps = (state) => ({ auth: state.auth });
export default connect(mapStateToProps, actions)(withRouter(InfoSection));